var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCoinLine = function SvgCoinLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12 4.8c5.468 0 9.9 2.418 9.9 5.4v3.6c0 2.983-4.432 5.4-9.9 5.4-5.37 0-9.742-2.331-9.896-5.24L2.1 13.8v-3.6c0-2.982 4.432-5.4 9.9-5.4m0 10.8c-3.348 0-6.309-.905-8.1-2.294v.495c0 1.694 3.495 3.6 8.1 3.6 4.509 0 7.954-1.827 8.096-3.494l.004-.106v-.495C18.31 14.694 15.35 15.6 12 15.6m0-9c-4.605 0-8.1 1.907-8.1 3.6 0 1.695 3.495 3.6 8.1 3.6s8.1-1.905 8.1-3.6c0-1.693-3.495-3.6-8.1-3.6"
  })));
};
export default SvgCoinLine;